// @ts-nocheck
export default {
  p1c4cef00:
    "M14.671 27.2119C14.671 17.6439 18.923 13.7109 29.129 13.817V13.4979C18.923 13.4979 14.671 9.45801 14.671 0H14.352C14.352 9.45801 10.206 13.4979 0 13.4979V13.817C10.206 13.7109 14.352 17.6439 14.352 27.2119H14.671Z",
};
